import rawIconData from "@/vendor/icons.json";
import { addCollection, setCustomIconsLoader, type IconifyJSON } from "@iconify/vue";
import { difference } from "es-toolkit";

//
// gen-icons builds vendor/icons.json, which we load here and make available to
// Iconify. In dev we try to notice missing icons and encourage the user to run
// gen-icons again. We go to great lengths to avoid the iconify api.
//

const iconData = rawIconData as { [key: string]: IconifyJSON };

export async function initIconify() {
  // add icons.json to iconify
  for (const data of Object.values(iconData)) {
    addCollection(data);
  }

  //
  // in dev, complain loudly on missing icons
  //

  if (import.meta.env.MODE === "development") {
    function customLoader(icons: string[], prefix: string): IconifyJSON | null {
      const collection = iconData[prefix];
      if (!iconData[prefix]) {
        console.error(`icons.json '${prefix}' not found, run gen-icons?`);
        return null;
      }
      const missing = difference(icons, Object.keys(collection.icons));
      if (missing.length) {
        console.error(`icons.json '${prefix}' is missing icon(s) '${missing}', run gen-icons?`);
      }
      return collection;
    }

    const collections = Object.keys(await import("@iconify/collections/collections.json"));
    collections.push("custom");
    for (const collection of collections) {
      setCustomIconsLoader(customLoader, collection);
    }
  }
}
